export function mascararCPF(cpf) {
  const cpfLimpo = cpf.replace(/\D/g, '');
  if (cpfLimpo.length !== 11) {
    throw new Error('CPF inválido. Deve conter 11 dígitos.');
  }
  return cpfLimpo.replace(/^(\d{3})\d{3}\d{3}(\d{2})$/, '$1.***.***-$2');
}